// #958: valida os digitos verificadores do CPF (com ou sem mascara).
export const isValidCpf = (value) => {
  const cpf = String(value ?? "").replace(/\D/g, "");
  if (cpf.length !== 11 || /^(\d)\1{10}$/.test(cpf)) return false;

  const checkDigit = (length) => {
    let sum = 0;
    for (let i = 0; i < length; i++) {
      sum += Number(cpf[i]) * (length + 1 - i);
    }
    const rest = (sum * 10) % 11;
    return rest === 10 ? 0 : rest;
  };

  return checkDigit(9) === Number(cpf[9]) && checkDigit(10) === Number(cpf[10]);
};

// CPF novo ou alterado precisa ser valido; o valor ja gravado passa, para nao
// travar a edicao de cadastro antigo (mesma regra da API).
export const cpfValidOrUnchanged = (savedValue) => (value) =>
  (!!savedValue && String(value ?? "").replace(/\D/g, "") === savedValue) ||
  isValidCpf(value);

export const invalidCpfMsg = { message: "CPF inválido" };
